import { filter, _filter } from "./filter";

/**
 * {@inheritDoc filter}
 */

export const where = filter;
/**
 * {@inheritDoc _filter}
 */
export const _where = _filter;
